module.exports = __webpack_public_path__ + "static/media/contractors.f9c8c8e6.svg";